import React from "react";
import { useApp } from "../../contexts";

export const ItemGrab = ({ value, ...props }) => {
  const { T } = useApp();
  const { btnAction, className, title, description } = props;

  return (
    <div className={`w-full ${className}`}>
      <div
        className="text-black font-semibold text-[24px]/[30px] xl:text-[37px]/[50px] title uppercase xl:w-[280px] lg:w-[250px] md:w-[250px] w-[180px]"
        dangerouslySetInnerHTML={{
          __html: T(title),
        }}
      ></div>
      <div
        className={`w-[180px] md:w-[300px] lg:w-[250px] xl:w-[300px] 3xl:w-[350px] font-semibold text-black text-[14px]/[20px] description`}
        dangerouslySetInnerHTML={{
          __html: T(description),
        }}
      ></div>
      <div
        className={`flex justify-start items-center gap-4 mt-2 lg:mt-[40px]`}
      >
        <button
          className="earn-big-btn !bg-black text-white font-semibold py-2 px-5 rounded-[10px] h-[50px]"
          onClick={btnAction}
        >
          {T("Redeem Now")}
        </button>
      </div>
    </div>
  );
};
